import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {PaginationEventData} from './models/paginationEventData';
import {PaginationService} from './services/pagination.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination-top.component.html',
  styleUrls: ['./pagination-top.component.less']
})
export class PaginationTopComponent implements OnInit, OnDestroy {
  @Input() public totalRecordsCount: number = 0;
  @Input() public paginationOverride: number;
  @Output() paginationChanged = new EventEmitter<PaginationEventData>();

  constructor(public pagination: PaginationService, public auth : AuthService) {
    pagination.resetValues();
  }

  public get overhand(): number {
    if(this.paginationOverride && this.paginationOverride > 0) return this.paginationOverride;
    const total = Math.abs(+this.pagination.offsetCount + +this.pagination.pageIncrement);
    return (total > this.totalRecordsCount ? this.totalRecordsCount : total);

  }

  
  // public get paginator() : boolean {
  //   return this.auth.UserIn
  //   return 
  // }
  

  ngOnDestroy(): void {
    this.pagination.currentPage = 1;
    this.pagination.offsetCount = 0;
  }

  ngOnInit() {
  }

  public resetPageSize(pageSize: number): void {
    this.pagination.setPageIncrement(pageSize);
    this.paginationChanged.emit(new PaginationEventData(this.pagination.offsetCount, this.pagination.pageIncrement));
  }

  public incrementPages(movement: string, log: boolean = false) {
    if (movement === 'backward') {
      this.pagination.currentPage--;
      this.pagination.offsetCount = ((this.pagination.currentPage === 1 ? 0 : (this.pagination.currentPage - 1)) * this.pagination.pageIncrement);
      this.paginationChanged.emit(new PaginationEventData(this.pagination.offsetCount, this.pagination.pageIncrement));
    }
    if (movement === 'forward') {
      this.pagination.offsetCount = (this.pagination.currentPage * this.pagination.pageIncrement);
      this.pagination.currentPage++;
      this.paginationChanged.emit(new PaginationEventData(this.pagination.offsetCount, this.pagination.pageIncrement));
    }
    if (movement === 'reset') {
      this.pagination.currentPage = 1;
      this.pagination.offsetCount = 0;
      this.paginationChanged.emit(new PaginationEventData(this.pagination.offsetCount, this.pagination.pageIncrement));
    }
    if (movement === 'end') {
      this.pagination.currentPage = Math.floor((this.totalRecordsCount) / this.pagination.pageIncrement);
      this.pagination.offsetCount = (this.pagination.currentPage * this.pagination.pageIncrement);
      this.paginationChanged.emit(new PaginationEventData(this.pagination.offsetCount, this.pagination.pageIncrement));

    }
  }

}
